export default "__VITE_ASSET__tDqdtDuw__"